// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --circle-size: clamp(0.75rem, 2.5vw, 1.5rem);
  --spacing: clamp(0.25rem, 2vw, 0.5rem);
  --stepper-color:red;
  --stepper-content-color:white;
  --stepper-content:"";
}

.c-stepper {
  display: flex;
}

.c-stepper__item {
  display: flex;
  flex-direction: column;
  flex: 0.25;
  text-align: center;
}
.c-stepper__item:before {
  --size: 3rem;
  content: var(--stepper-content);
  display: block;
  color: var(--stepper-content-color);
  width: clamp(0.75rem, 2.5vw, 1.5rem);
  height: clamp(0.75rem, 2.5vw, 1.5rem);
  border-radius: 50%;
  background-color: lightgrey;
  background-color: var(--stepper-color);
  margin: 0 auto 1rem;
}
.c-stepper__item:not(:last-child):after {
  content: "";
  position: relative;
  top: calc(clamp(0.75rem, 2.5vw, 1.5rem) / 2);
  width: calc(100% - clamp(0.75rem, 2.5vw, 1.5rem) - clamp(0.25rem, 2vw, 0.5rem) * 2);
  left: calc(50% + clamp(0.75rem, 2.5vw, 1.5rem) / 2 + clamp(0.25rem, 2vw, 0.5rem));
  height: 2px;
  background-color: #000000;
  order: -1;
}

.c-stepper__title {
  font-weight: bold;
  font-size: clamp(1rem, 4vw, 1.25rem);
  margin-bottom: 0.5rem;
}

.c-stepper__desc {
  color: grey;
  font-size: clamp(0.85rem, 2vw, 1rem);
  padding-left: clamp(0.25rem, 2vw, 0.5rem);
  padding-right: clamp(0.25rem, 2vw, 0.5rem);
}

.dropdown-menu {
  min-width: 240px;
  width: 30%;
  background-color: #FFFFFF;
  margin: -3px -1px;
  padding: 0;
  border-radius: 0px;
  overflow-y: auto;
  max-height: 30vh;
  position: absolute !important;
  left: 50% !important;
  transform: translate(-50%, 27px) !important;
  /* border-top: 2px solid #29BB73;  */
}
.dropdown-menu span.icon-edit {
  float: right;
  color: #490050;
  font-size: 20px;
  cursor: pointer;
}
.dropdown-menu hr {
  margin: 0;
}
.dropdown-menu > div {
  padding: 0px 9px;
}
.dropdown-menu .add-span {
  color: #29BB73;
  font-weight: bold;
  font-size: 12px;
}

.menu-row {
  padding: 5px;
  align-items: center;
  min-height: 20px;
}

.menu-box {
  min-height: 20px;
  border-radius: 3px;
}

.btn-align-center {
  text-align: center;
}

.btn {
  padding: 5px;
}

.broadcaster-name {
  font-weight: bold;
  text-align: right;
  vertical-align: middle;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-dashboard/stepper/another-stepper.scss"],"names":[],"mappings":"AAAA;EACI,4CAAA;EACA,sCAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AACJ;AAEI;EACE,YAAA;EACA,+BAAA;EACA,cAAA;EACA,mCAAA;EACA,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,2BAAA;EACA,sCAAA;EACA,mBAAA;AAAN;AAIM;EACE,WAAA;EACA,kBAAA;EACA,4CAAA;EACA,mFAAA;EACA,iFAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;AAFR;;AAOE;EACE,iBAAA;EACA,oCAAA;EACA,qBAAA;AAJJ;;AAOE;EACE,WAAA;EACA,oCAAA;EACA,yCAAA;EACA,0CAAA;AAJJ;;AAOE;EACE,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,2CAAA;EAGA,oCAAA;AANJ;AASI;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAPN;AAUI;EACE,SAAA;AARN;AAWI;EACE,gBAAA;AATN;AAYI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAVN;;AAcE;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;;AAcE;EACG,gBAAA;EACA,kBAAA;AAXL;;AAcE;EACE,kBAAA;AAXJ;;AAaE;EACE,YAAA;AAVJ;;AAYC;EACC,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;AATF","sourcesContent":[":host {\n    --circle-size: clamp(0.75rem, 2.5vw, 1.5rem);\n    --spacing: clamp(0.25rem, 2vw, 0.5rem);\n    --stepper-color:red;\n    --stepper-content-color:white;\n    --stepper-content:\"\";\n    }\n  \n  .c-stepper {\n    display: flex;\n  }\n  \n  .c-stepper__item {\n    display: flex;\n    flex-direction: column;\n    flex: 0.25;\n    text-align: center;\n  \n  \n    &:before {\n      --size: 3rem;\n      content: var(--stepper-content);\n      display: block;\n      color:var(--stepper-content-color);\n      width: clamp(0.75rem, 2.5vw, 1.5rem);\n      height: clamp(0.75rem, 2.5vw, 1.5rem);\n      border-radius: 50%;\n      background-color: lightgrey;\n      background-color:var(--stepper-color);\n      margin: 0 auto 1rem;\n    }\n  \n    &:not(:last-child) {\n      &:after {\n        content: \"\";\n        position: relative;\n        top: calc(clamp(0.75rem, 2.5vw, 1.5rem) / 2);\n        width: calc(100% - clamp(0.75rem, 2.5vw, 1.5rem) - calc(clamp(0.25rem, 2vw, 0.5rem) * 2));\n        left: calc(50% + calc(clamp(0.75rem, 2.5vw, 1.5rem) / 2 + clamp(0.25rem, 2vw, 0.5rem)));\n        height: 2px;\n        background-color: #000000;\n        order: -1;\n      }\n    }\n  }\n  \n  .c-stepper__title {\n    font-weight: bold;\n    font-size: clamp(1rem, 4vw, 1.25rem);\n    margin-bottom: 0.5rem;\n  }\n  \n  .c-stepper__desc {\n    color: grey;\n    font-size: clamp(0.85rem, 2vw, 1rem);\n    padding-left: clamp(0.25rem, 2vw, 0.5rem);\n    padding-right: clamp(0.25rem, 2vw, 0.5rem);\n  }\n\n  .dropdown-menu {\n    min-width: 240px;\n    width: 30%;\n    background-color: #FFFFFF;\n    margin: -3px -1px;\n    padding: 0;\n    border-radius: 0px;\n    overflow-y: auto;\n    max-height: 30vh;\n    position: absolute!important;\n    left:50%!important;\n    transform: translate(-50%,27px)!important;\n    \n\n    /* border-top: 2px solid #29BB73;  */\n \n\n    span.icon-edit {\n      float: right;\n      color: #490050;\n      font-size: 20px;\n      cursor: pointer;\n    }\n\n    hr {\n      margin: 0;\n    }\n\n    & > div {\n      padding: 0px 9px;\n    }\n\n    .add-span {\n      color: #29BB73;\n      font-weight: bold;\n      font-size: 12px;\n    }\n    \n  }\n  .menu-row {\n    padding: 5px;\n    align-items: center;\n    min-height: 20px;\n   \n  }\n  .menu-box {\n     min-height: 20px;\n     border-radius: 3px;\n  }\n\n  .btn-align-center{\n    text-align: center;\n  }\n  .btn {\n    padding: 5px;\n }\n .broadcaster-name{\n  font-weight: bold;\n  text-align: right;\n  vertical-align: middle;\n  padding: 10px;\n }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
